// import { amgApi } from "@/service/axios";

import axios from "@/axios"

const url = "/api/tournament/general"

class GeneralTournamentService {
	async index() {
		try {
			const { data } = await axios.get(url)
			return data
		} catch (error) {
			console.log("error", error)
		}
	}

	async store({ name }) {
		try {
			const data = await axios.post(url, {
				name,
			})
			x
			return data
		} catch (error) {
			console.log("error", error)
		}
	}

	async indexImages() {
		try {
			const { data } = await axios.get("/api/tournament/avatars/")
			return data
		} catch (error) {
			console.log("error", error)
		}
	}

	async destroyImage(id) {
		try {
			await axios.delete(`/api/tournament/avatars/${id}`)
		} catch (error) {
			console.log("error", error)
		}
	}

	async updateImage(id, params) {
		try {
			const { data } = await axios.put(`/api/tournament/avatars/${id}`, params)
			return data
		} catch (error) {
			throw error
		}
	}
}
export default new GeneralTournamentService()
